// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/2596087f07bff0e2ea8a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"f1215d5e21248295c28c","148":"32ddb1e4272645c9ffeb","149":"57bac35f297dd0978565"}[chunkId] + ".chunk.js";
};